var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWashingMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4313_2942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56406 4.02646H3.57M3.56406 11.1547H3.57M2.37602 1.65039H11.8803C12.5364 1.65039 13.0683 2.18229 13.0683 2.83842V5.21449C13.0683 5.87063 12.5364 6.40253 11.8803 6.40253H2.37602C1.71989 6.40253 1.18799 5.87063 1.18799 5.21449V2.83842C1.18799 2.18229 1.71989 1.65039 2.37602 1.65039ZM2.37602 8.7786H11.8803C12.5364 8.7786 13.0683 9.3105 13.0683 9.96663V12.3427C13.0683 12.9988 12.5364 13.5307 11.8803 13.5307H2.37602C1.71989 13.5307 1.18799 12.9988 1.18799 12.3427V9.96663C1.18799 9.3105 1.71989 8.7786 2.37602 8.7786Z",
    stroke: "white",
    strokeWidth: 1.42564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4313_2942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2564,
    height: 14.2564,
    fill: "white",
    transform: "translate(0 0.460938)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMethod);
export default __webpack_public_path__ + "static/media/washingMethod.461cde88341a8744d8a66e014b6165ed.svg";
export { ForwardRef as ReactComponent };